module.exports = __webpack_public_path__ + "img/product.a556cd59.png";